export default __webpack_public_path__ + "static/media/coconut.ad2fd637.png";